<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Usuarios",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
            ],
            usuarios:[],
            datos_editar:{
                sede:'',
                tipo:'',
                rut:'',
                nombre:'',
                correo:'',
                telefono:'',
            },
            habilitar_boton: false,  
            editing: false,
            originalUser:'',
            emailError:'',
            phoneerror:'',
            ruterror:'',
            sedes:['Viña del Mar', 'Santiago', 'Concepción'],
            cargos:['Coordinador Vigente','Coordinador de reemplazo','Supervisor','Supervisor General'],
            busqueda: ''
        };
    },
    computed: {
        filteredUsuarios() {
            const query = (this.busqueda || '').toLowerCase().trim();

            if (!query) {
                return this.usuarios;
            }

            return this.usuarios.filter((usuario) => {
                return [usuario.name, usuario.rut]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase()
                    .includes(query);
            });
        }
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        rolBadgeClass(rol) {
            const nombreRol = String(rol || '').toLowerCase();

            if (nombreRol.includes('admin')) {
                return 'usuarios-role-badge--admin';
            }

            if (nombreRol.includes('coordin')) {
                return 'usuarios-role-badge--coordinador';
            }

            if (nombreRol.includes('super')) {
                return 'usuarios-role-badge--supervisor';
            }

            return 'usuarios-role-badge--default';
        },
        toggleEdit(usuario) {
            this.originalUser = { ...usuario };
            if (this.editing) {
                this.isLoading=true
                axios.post('/api/editar_usuario',this.datos_editar).then(res=>{
                    if(res.data.estado){
                        this.usuarios=res.data.usuarios;
                        this.msg(res.data.color,res.data.mensaje);
                        //window.location.reload(); 
                    }else{
                        this.msg(res.data.color,res.data.mensaje);
                    }
                    this.isLoading=false
                })
            }else{
                this.datos_editar.id=usuario.id;
                this.datos_editar.name=usuario.name;
                this.datos_editar.rut=usuario.rut;
                this.datos_editar.sede=usuario.sede;
                this.datos_editar.email=usuario.email;
                this.datos_editar.cargo=usuario.cargo;
                this.datos_editar.telefono=usuario.telefono;
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        ver_mas(usuario){
            this.editing = false;
            if (usuario.boton=='Ver más') {
                usuario.boton='Ver menos'
            }else if(usuario.boton=='Ver menos'){
                usuario.boton='Ver más'
            }
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos_editar.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos_editar.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos_editar.rut = cleanRut;
            }
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        validateRut() {
            let rut = this.cleanRut(this.datos_editar.rut);
            let digito_verificador = this.datos_editar.rut.substr(-1);
            rut = rut.substr(0, rut.length - 1);
            let serie = 0;
            let producto = 0;
            do {
                producto += (rut % 10) * ((serie % 6) + 2);
                serie++;
            } while (rut = Math.floor(rut / 10));
            let resto = producto % 11;
            let resultado = 11 - resto;
            if (resultado == 11) {
                resultado = 0;
            } else if (resultado == 10) {
                resultado = 'K';
            }
            if (digito_verificador != resultado || digito_verificador=='') {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        validateEmail() {
            if (this.datos_editar.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos_editar.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos_editar.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos_editar.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        eliminar(usuario){
            let formData = new FormData();
            formData.append('usuario_id', usuario.id);
            axios.post('/api/eliminar_usuario',formData).then(res=>{
                if(res.data.estado){
                    this.usuarios=res.data.usuarios;
                    this.msg(res.data.color,res.data.mensaje);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
            })
        }
    },
    created(){
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios;
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card usuarios-card">
                    <div class="card-header usuarios-header">
                        <i class="bx bx-group usuarios-header__icon"></i>
                        <div>
                            <h5 class="usuarios-header__title">Gestión de Usuarios</h5>
                            <small class="usuarios-header__subtitle">Administra los usuarios de la plataforma</small>
                        </div>
                    </div>

                    <div class="card-body usuarios-card-body">
                        <div class="row usuarios-toolbar align-items-center">
                            <div class="col-md-6 mb-3 mb-md-0">
                                <b-input-group class="usuarios-search">
                                    <b-input-group-prepend is-text>
                                        <i class="bx bx-search-alt"></i>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="busqueda" placeholder="Buscar por nombre o RUT..." />
                                </b-input-group>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <a class="btn usuarios-primary-btn" href="/web/configuracion/crearusuario">
                                    <i class="bx bx-user-plus mr-1"></i> Agregar Usuario
                                </a>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-hover usuarios-table mb-0">
                                <thead>
                                    <tr>
                                        <th class="usuarios-table__index">#</th>
                                        <th>Nombre</th>
                                        <th class="usuarios-table__rut">RUT</th>
                                        <th class="usuarios-table__role">Rol</th>
                                        <th class="usuarios-table__detail">Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="filteredUsuarios.length === 0">
                                        <td colspan="5" class="text-center text-muted py-4">
                                            <i class="bx bx-user-x usuarios-empty__icon"></i>
                                            No se encontraron usuarios.
                                        </td>
                                    </tr>

                                    <template v-for="(usuario, index) in filteredUsuarios">
                                        <tr :key="'row-' + usuario.id">
                                            <td class="align-middle text-muted small usuarios-table__index">{{ index + 1 }}</td>
                                            <td class="align-middle usuarios-table__name">
                                                <i class="bx bx-user-circle usuarios-table__user-icon"></i>
                                                {{ usuario.name }}
                                            </td>
                                            <td class="align-middle text-muted">{{ usuario.rut || '-' }}</td>
                                            <td class="align-middle">
                                                <span class="badge usuarios-role-badge" :class="rolBadgeClass(usuario.rol)">
                                                    {{ usuario.rol || '-' }}
                                                </span>
                                            </td>
                                            <td class="align-middle text-right usuarios-table__detail">
                                                <b-button
                                                    size="sm"
                                                    class="usuarios-detail-btn"
                                                    v-b-toggle="'usuario-' + usuario.id"
                                                    @click="ver_mas(usuario)"
                                                >
                                                    <i :class="usuario.boton === 'Ver menos' ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                                                    {{ usuario.boton || 'Ver más' }}
                                                </b-button>
                                            </td>
                                        </tr>

                                        <tr :key="'collapse-' + usuario.id">
                                            <td colspan="5" class="p-0 border-0 usuarios-collapse-cell">
                                                <b-collapse :id="'usuario-' + usuario.id" accordion="usuarios-accordion" role="tabpanel">
                                                    <div class="usuarios-collapse-content">
                                                        <div v-if="!editing" class="row">
                                                            <div class="col-md-6">
                                                                <div class="usuarios-detail-heading">
                                                                    <span class="usuarios-detail-heading__bar"></span>
                                                                    <h6>{{ usuario.name }}</h6>
                                                                </div>
                                                                <p class="usuarios-detail-field"><strong>Correo Electrónico:</strong> {{ usuario.email }}</p>
                                                                <p class="usuarios-detail-field"><strong>Teléfono:</strong> {{ usuario.telefono || '-' }}</p>
                                                                <p class="usuarios-detail-field"><strong>Nº Colegios Asignados:</strong> {{ usuario.colegios_asignados }}</p>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="usuarios-detail-field"><strong>Rut:</strong> {{ usuario.rut || '-' }}</p>
                                                                <p class="usuarios-detail-field"><strong>Sede:</strong> {{ usuario.sede || '-' }}</p>
                                                                <p class="usuarios-detail-field"><strong>Tipo de Usuario:</strong> {{ usuario.cargo || '-' }}</p>
                                                            </div>
                                                            <div class="col-12 usuarios-detail-actions">
                                                                <b-button size="sm" class="usuarios-edit-btn" @click="toggleEdit(usuario)">
                                                                    <i class="bx bx-edit mr-1"></i> Editar
                                                                </b-button>
                                                                <b-button size="sm" variant="danger" @click="eliminar(usuario)">
                                                                    <i class="bx bx-trash mr-1"></i> Eliminar
                                                                </b-button>
                                                            </div>
                                                        </div>

                                                        <div v-if="editing && datos_editar.id === usuario.id">
                                                            <div class="usuarios-detail-heading">
                                                                <span class="usuarios-detail-heading__bar usuarios-detail-heading__bar--accent"></span>
                                                                <h6>Editando: {{ usuario.name }}</h6>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Nombre:</label>
                                                                        <input type="text" v-model="datos_editar.name" class="form-control" @keydown="restrictInput_withspace">
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label>Sede:</label>
                                                                        <multiselect
                                                                            v-model="datos_editar.sede"
                                                                            :options="sedes"
                                                                            placeholder="Seleccionar opción"
                                                                            selectLabel="Presiona para seleccionar"
                                                                            selectedLabel="Seleccionado"
                                                                            deselectLabel="Presiona para remover"
                                                                        >
                                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                                                        </multiselect>
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label>Correo Electrónico:</label>
                                                                        <input type="email" v-model="datos_editar.email" class="form-control" @blur="validateEmail">
                                                                        <p v-if="emailError" class="error text-danger">{{ emailError }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Rut:</label>
                                                                        <input type="text" v-model="datos_editar.rut" class="form-control" @blur="validateRut" @input="formatRut" maxlength="12">
                                                                        <p v-if="ruterror" class="error text-danger">{{ ruterror }}</p>
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label>Tipo de Usuario:</label>
                                                                        <multiselect
                                                                            v-model="datos_editar.cargo"
                                                                            :options="cargos"
                                                                            placeholder="Seleccionar opción"
                                                                            selectLabel="Presiona para seleccionar"
                                                                            selectedLabel="Seleccionado"
                                                                            deselectLabel="Presiona para remover"
                                                                        >
                                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                                                        </multiselect>
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label>Teléfono:</label>
                                                                        <input type="tel" v-model="datos_editar.telefono" class="form-control" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                                                        <p v-if="phoneerror" class="error text-danger">{{ phoneerror }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="usuarios-detail-actions usuarios-detail-actions--editing">
                                                                <b-button size="sm" variant="secondary" @click="cancelEdit">
                                                                    <i class="bx bx-x mr-1"></i> Cancelar
                                                                </b-button>
                                                                <b-button size="sm" class="usuarios-edit-btn" @click="toggleEdit(usuario)">
                                                                    <i class="bx bx-save mr-1"></i> Guardar cambios
                                                                </b-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                        <div class="usuarios-count">
                            <small>{{ filteredUsuarios.length }} usuario{{ filteredUsuarios.length !== 1 ? 's' : '' }} encontrado{{ filteredUsuarios.length !== 1 ? 's' : '' }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>
.usuarios-card {
    overflow: hidden;
    border: 0;
    border-radius: 0.75rem;
    box-shadow: 0 0.5rem 1.5rem rgba(42, 48, 66, 0.06);
}

.usuarios-header {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    padding: 1rem 1.25rem;
    border: 0;
    border-radius: 0.75rem 0.75rem 0 0;
    background: linear-gradient(90deg, #b86a2f 0%, #cf7e3a 55%, #e5a35f 100%);
    box-shadow: 0 16px 30px rgba(201, 126, 55, 0.22);
}

.usuarios-header__icon {
    color: #fff;
    font-size: 1.65rem;
}

.usuarios-header__title {
    margin: 0;
    color: #fff;
    font-weight: 700;
}

.usuarios-header__subtitle {
    color: rgba(255, 255, 255, 0.82);
}

.usuarios-card-body {
    padding: 1.5rem 1.25rem;
}

.usuarios-toolbar {
    margin-bottom: 1.35rem;
}

.usuarios-search .input-group-text {
    border-color: #e5e7eb;
    border-right: 0;
    background: #fff;
    color: #c87838;
}

.usuarios-search .form-control {
    border-color: #e5e7eb;
    border-left: 0;
    box-shadow: none;
}

.usuarios-search .form-control:focus {
    border-color: #c87838;
    box-shadow: 0 0 0 0.15rem rgba(200, 120, 56, 0.12);
}

.usuarios-primary-btn,
.usuarios-edit-btn {
    border-color: #c87838 !important;
    background: #c87838 !important;
    color: #fff !important;
}

.usuarios-primary-btn {
    min-height: 42px;
    padding: 0.65rem 1.1rem;
    font-weight: 600;
}

.usuarios-primary-btn:hover,
.usuarios-primary-btn:focus,
.usuarios-edit-btn:hover,
.usuarios-edit-btn:focus {
    border-color: #a85e2b !important;
    background: #a85e2b !important;
    color: #fff !important;
}

.usuarios-table {
    min-width: 680px;
}

.usuarios-table thead tr {
    background: #fff8f3;
}

.usuarios-table th {
    border-top: 0;
    border-bottom: 1px solid #eadfd7;
    color: #2a3042;
    font-size: 0.78rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.usuarios-table td {
    border-top: 1px solid #f0f1f4;
    color: #596270;
    vertical-align: middle;
}

.usuarios-table tbody tr:not(.usuarios-collapse-cell) {
    transition: background-color 0.15s ease;
}

.usuarios-table tbody tr:not(.usuarios-collapse-cell):hover {
    background: #fffaf6;
}

.usuarios-table__index {
    width: 48px;
}

.usuarios-table__rut {
    width: 150px;
}

.usuarios-table__role {
    width: 155px;
}

.usuarios-table__detail {
    width: 135px;
}

.usuarios-table__name {
    color: #2a3042 !important;
    font-weight: 600;
}

.usuarios-table__user-icon {
    margin-right: 0.35rem;
    color: #c87838;
    font-size: 1.1rem;
    vertical-align: -0.1rem;
}

.usuarios-role-badge {
    padding: 0.4rem 0.65rem;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 700;
}

.usuarios-role-badge--admin {
    background: #2a3042;
    color: #fff;
}

.usuarios-role-badge--coordinador {
    background: #c87838;
    color: #fff;
}

.usuarios-role-badge--supervisor {
    background: #e1a069;
    color: #fff;
}

.usuarios-role-badge--default {
    background: #74788d;
    color: #fff;
}

.usuarios-detail-btn {
    border-color: #c87838 !important;
    background: transparent !important;
    color: #a85e2b !important;
    font-weight: 600;
}

.usuarios-detail-btn:hover,
.usuarios-detail-btn:focus {
    border-color: #c87838 !important;
    background: #fff3e9 !important;
    color: #8f4f24 !important;
}

.usuarios-empty__icon {
    display: block;
    margin-bottom: 0.25rem;
    color: #c87838;
    font-size: 1.5rem;
}

.usuarios-collapse-cell {
    background: transparent !important;
}

.usuarios-collapse-content {
    padding: 1.25rem;
    border-left: 4px solid #c87838;
    background: #fffaf6;
}

.usuarios-detail-heading {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.usuarios-detail-heading__bar {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background: #c87838;
}

.usuarios-detail-heading__bar--accent {
    background: #2a3042;
}

.usuarios-detail-heading h6 {
    margin: 0;
    color: #2a3042;
    font-weight: 700;
}

.usuarios-detail-field {
    margin-bottom: 0.55rem;
    color: #596270;
    font-size: 0.9rem;
}

.usuarios-detail-field strong {
    color: #2a3042;
}

.usuarios-detail-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 1rem;
}

.usuarios-detail-actions--editing {
    margin-top: 0.25rem;
}

.usuarios-count {
    margin-top: 1rem;
    color: #74788d;
    text-align: right;
}

@media (max-width: 767px) {
    .usuarios-card-body {
        padding: 1rem 0.75rem;
    }

    .usuarios-toolbar .text-md-right {
        text-align: left !important;
    }

    .usuarios-primary-btn {
        width: 100%;
    }

    .usuarios-collapse-content {
        padding: 1rem;
    }

    .usuarios-detail-actions {
        justify-content: stretch;
        flex-direction: column;
    }

    .usuarios-detail-actions .btn {
        width: 100%;
    }
}
</style>